import React from 'react';

import SystemCard from 'components/Flux/Automatic/Classic/Mobile/SystemCards/SystemCard';
import buildClassicCards from 'helper/flux/classicCards';
import { ClassicData } from 'helper/flux/automatic';

import './index.scss';

export interface SystemCardsProps {
  data: ClassicData;
}

export default function SystemCards({ data }: SystemCardsProps) {
  const systemCards = buildClassicCards(data?.sistema);
  const subsystemCards = buildClassicCards(data?.subsistemas);

  if (!systemCards?.length && !subsystemCards?.length) return null;

  return (
    <div className="system-cards">
      {systemCards?.map((card) => <SystemCard card={card} key={card.label} />)}

      {!!subsystemCards?.length && (
        <>
          <span className="system-cards-group">SUBSISTEMAS</span>
          {subsystemCards.map((card) => <SystemCard card={card} key={card.label} />)}
        </>
      )}
    </div>
  );
}
